import type { ReactNode } from "react";
import { hasRequiredRole, type AdminRole } from "./roles";
import { useAccountRoles } from "./useAccountRoles";

interface RequireRoleProps {
  /** Minimum role required to render `children`. */
  role: AdminRole;
  children: ReactNode;
}

/**
 * Hides `children` entirely (renders nothing) unless the signed-in
 * principal's role satisfies `role` (task 6.2). Used to gate every write
 * action (suprimir/revertir/crear/programar/cancelar/despachar) per
 * `admin-panel-ui` "Restricciones de rol Consulta". El rol se resuelve de
 * forma asincronica (ver `useAccountRoles`, roles vienen del access token,
 * no del ID token) — hasta resolverse queda oculto (fail-closed).
 */
export function RequireRole({ role, children }: RequireRoleProps): ReactNode {
  const roles = useAccountRoles();

  if (!hasRequiredRole(roles, role)) {
    return null;
  }

  return children;
}
